module.exports = __webpack_public_path__ + "img/uid-token-bg-hen.8d81ce9e.png";